/**
 * Get MIME type for file based on extension when browser detection fails
 * @param fileName - Name of file including extension
 * @param browserType - MIME type detected by browser (file.type)
 * @returns Appropriate MIME type string
 */
export const getMimeType = (fileName: string, browserType: string): string => {
  // Use browser-detected type if available
  if (browserType && browserType.trim() !== "") {
    return browserType;
  }

  // Extract file extension (handle double extensions like .csv.gpg)
  const lowerFileName = fileName.toLowerCase();

  // Check for GPG encrypted files first (most specific)
  if (lowerFileName.endsWith('.csv.gpg')) {
    return 'application/pgp-encrypted';
  }

  if (lowerFileName.endsWith('.txt.gpg')) {
    return 'application/pgp-encrypted';
  }

  if (lowerFileName.endsWith('.gpg')) {
    return 'application/pgp-encrypted';
  }

  // Standard file extensions
  if (lowerFileName.endsWith('.csv')) {
    return 'text/csv';
  }

  if (lowerFileName.endsWith('.txt')) {
    return 'text/plain';
  }

  if (lowerFileName.endsWith('.pdf')) {
    return 'application/pdf';
  }

  if (lowerFileName.endsWith('.json')) {
    return 'application/json';
  }

  if (lowerFileName.endsWith('.xml')) {
    return 'application/xml';
  }

  // Default fallback for unknown types
  return 'application/octet-stream';
};
